const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const sortBy = payload.sortBy?.[0] ? `${payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;
  //     const params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       roleId: payload.role,
  //       status: payload.status,
  //       sortBy
  //     };

  //     let url = `/api/user/school-admin`;
  //     if ((payload.status !== '' && typeof payload.status != 'undefined') || payload.role) {
  //       url = url.concat(`/filter`);
  //     }

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });
  //     const { content, totalPages, totalElements } = data;

  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/school-admin?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  async fetchFilter(_, { roleId, status, search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/school-admin/filter?roleId=${roleId ?? ''}&status=${status ?? ''}&search=${search ?? ''}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/user/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  save({ rootGetters }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    formData.append('schoolId', rootGetters['Auth/currentSchool']);
    if (!payload.image) formData.delete('image');
    return window.axios.post('/api/user/school-admin/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // eslint-disable-next-line no-unused-vars
  update({ rootGetters }, payload) {
    if (payload.lastName === null) {
      payload.lastName = '';
    }
    if (payload.postalCode === null) {
      payload.postalCode = '';
    }
    if (payload.phoneNumber === null) {
      payload.phoneNumber = '';
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    formData.append('schoolId', rootGetters['Auth/currentSchool']);
    if (!payload.image) formData.delete('image');
    return window.axios.put(`/api/user/school-admin/${payload.id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/user/${payload.userId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
